export default "__VITE_ASSET__94685427__"